import { useEffect } from "react";
import { useFormLogic } from "../context/FormLogicContext";
import { NormalizedClearInvisibleValues, } from "../../../types/forms";
export var useClearInvisibleValue = function (_a) {
    var isVisible = _a.isVisible, valueKeys = _a.valueKeys, unregister = _a.unregister, _b = _a.reason, reason = _b === void 0 ? "own" : _b;
    var clearInvisibleValues = useFormLogic().clearInvisibleValues;
    var shouldClear = reason === "container"
        ? clearInvisibleValues ===
            NormalizedClearInvisibleValues.ON_HIDDEN_CONTAINER
        : clearInvisibleValues === NormalizedClearInvisibleValues.ON_HIDDEN ||
            clearInvisibleValues ===
                NormalizedClearInvisibleValues.ON_HIDDEN_CONTAINER;
    var valueKeysSignature = valueKeys.join(",");
    useEffect(function () {
        if (!isVisible && shouldClear) {
            valueKeys.forEach(function (key) { return unregister(key); });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isVisible, shouldClear, valueKeysSignature, unregister]);
};
